<template>
  <div class="market-notice">
    <div class="notice-item">
      ■{{ t('未出品の状態で24時間に販売価格を設定されていなければ、自動でコインへ還元されます。') }}
    </div>
    <div class="notice-item">
      ■{{ t('マーケットへ出品して2週間経過して売れなかった場合は、自動でコインへ還元されます。') }}
    </div>
    <div class="notice-item">
      ■{{ t('出品開始後2週間以内なら、「コインへ還元」「発送依頼」を自由に変更できます。') }}
    </div>
    <div class="notice-item">
      ■{{ t('販売手数料として10%を頂戴いたします。') }}
    </div>
    <div class="notice-item">
      <span @click="handleLinkClick" class="link">
        ■{{ t('売上金についてはこちらをご確認ください。') }}
      </span>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'MarketNotice',
  mixins: [t],
  methods: {
    handleLinkClick() {
      this.$router.push('/request-payment');
    },
  },
};
</script>

<style lang="scss" scoped>
.market-notice {
  // background-color: #f8f9fa;
  // border: 1px solid #e9ecef;
  // border-radius: 8px;
  padding: 16px;
  margin: 0 0 16px 0;
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
  .notice-item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    .link {
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #2f3338 !important;
        text-decoration: underline;
      }
    }
  }
}
@media (max-width: 768px) {
  .market-notice {
    margin: 0;
    padding: 10px;
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>
